import MultiplePlaylistsAddModalGraphql from './MultiplePlaylistsAddModalGraphql'

export default MultiplePlaylistsAddModalGraphql
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsAddModalGraphql'
